import type { ReactNode } from "react";
import Card, { type CardProps } from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import CardHeader from "@mui/material/CardHeader";
import Box from "@mui/material/Box";
import { useCloseLoadingBackdropOverlay } from "ui/layouts/LoadingBackdropOverlay";
import { useOnboardingStep } from "ui/organizms/ECommerce/Onboarding/common";
import type { WithStep } from "../hooks";

type Props = WithStep<
    & Omit<CardProps, 'title'>
    & {
        readonly title: ReactNode;
    }
>;

const Step = ({
    children,
    title,
    route,
    getApplicationModel,
    ...restProps
}: Props) => {
    useCloseLoadingBackdropOverlay();

    const {
        getTotalStepsCount,
        getCurrentStepIndex
    } = useOnboardingStep({
        route,
        getApplicationModel
    });

    return (
        <Card
            {...restProps}
            sx={{
                my: 3,
                p: 3,
                height: 'min-content',
                width: '100%',
                ...restProps.sx
            }}
        >
            <CardHeader
                sx={{
                    p: 0
                }}
                title={(
                    <>
                        <Typography
                            variant='subtitle1'
                            color={theme => theme.palette.primary.main}
                            gutterBottom={false}
                        >
                            Step {getCurrentStepIndex()}/{getTotalStepsCount()}
                        </Typography>
                        <Typography
                            variant='h4'
                            sx={{
                                fontWeight: 500
                            }}
                            gutterBottom
                        >
                            {title}
                        </Typography>
                    </>
                )}
            />
            <Box
                sx={{
                    mt: 2
                }}
            >
                {children}
            </Box>
        </Card>
    );
};

export default Step;
